import { getProfileUrl } from "./getAboutPagesWithHref";

export const getAuthorPageUrl = (isProfilePagePublic: boolean, isMainDomain: boolean, userSlug: string, smartShareUrl?: string) => {
    if (isProfilePagePublic) {
        return getProfileUrl(userSlug, isMainDomain, smartShareUrl);
    }
    return undefined;
};
